import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode"; // Importação correta como named export
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";

const AdminNavbar = (props) => {
  const navigate = useNavigate(); // Hook para redirecionar
  const [username, setUsername] = useState(""); // Estado para armazenar o nome do usuário

  // Função de logout
  const handleLogout = () => {
    localStorage.removeItem("token"); // Remove o token do LocalStorage
    navigate("/auth/login"); // Redireciona para a página de login
  };

  // Função para obter o nome do usuário do token JWT
  useEffect(() => {
    const token = localStorage.getItem("token"); // Obtém o token do LocalStorage
    if (token) {
      try {
        const decodedToken = jwtDecode(token); // Decodifica o token
        setUsername(decodedToken.username); // Define o nome do usuário (assegure-se de que o nome está no campo correto do token)
      } catch (error) {
        console.error("Token inválido", error);
      }
    }
  }, []); // O useEffect é executado quando o componente é montado

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  {/* <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={require("../../assets/img/theme/team-4-800x800.jpg")}
                    />
                  </span> */}
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {username || "Usuário"}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu container="body" className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Bem-vindo!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>Meu perfil</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Configurações</span>
                </DropdownItem>
                {/* <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Atividades</span>
                </DropdownItem> */}
                <DropdownItem
                  href="https://wa.me/5583998262156"
                  target="_blank" // Abre em uma nova aba
                  rel="noopener noreferrer" // Recomendado por segurança para links externos
                >
                  <i className="ni ni-support-16" />
                  <span>Suporte</span>
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem href="#" onClick={handleLogout}>
                  <i className="ni ni-user-run" />
                  <span>Sair</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
